export const buttonItemLayout = {wrapperCol: {span: 10}};
export const formLayout = {
    labelCol: {span: 3, offset: 1},
    wrapperCol: {span: 10, offset: 1},
};
